/* ============================================================
 * Vibee PDP Stories — full-screen vertical video player.
 *
 * SAFETY: This entire file is wrapped in a single IIFE + try/catch.
 * It is pure progressive enhancement: the bubbles are real <button>s
 * rendered server-side, so if anything here throws the page stays
 * usable, the gallery is untouched, and nothing blanks. This file
 * MUST NOT depend on or modify vibee-pdp.js / vibee-judgeme-state.js.
 *
 * iOS/WebKit sağlamlık kararları (1 Eyl 2026 — "siyah ekran" vakası):
 *  1. Kaynak JS'te seçilir ve video.src'ye DOĞRUDAN atanır — dinamik
 *     <source> çocukları iOS'ta güvenilmez (Apple'ın belgelediği kısıt).
 *  2. Her story için TAZE <video> elementi yaratılır — src-swap sonrası
 *     WebKit katman bayatlaması (oynayan ama boyamayan video) böyle önlenir.
 *  3. Videonun HİÇBİR atasında transition yok — opacity/visibility geçişli
 *     fixed overlay, WebKit'te videonun composite edilmemesine yol açabiliyor.
 *     Player anında açılır (display toggle).
 *  4. Dokunma bölgeleri <div role=button> — <button> WebKit/iOS'ta native
 *     opak yüzey boyayabiliyor (ekranı kaplayan zone'lar = siyah/beyaz ekran).
 *  5. play() bubble tıklamasının JEST BAĞLAMINDA çağrılır; muted attribute
 *     (property değil) autoplay politikası için baştan set edilir.
 *  6. ?storydebug=1 → sol-alt köşede canlı teşhis rozeti.
 * ============================================================ */
(function () {
  'use strict';

  try {
    var module = document.querySelector('.vibee-stories[data-module-key="stories"]');
    if (!module) return;

    var dataEl = module.querySelector('script[data-vibee-stories]');
    if (!dataEl) return;

    var stories = [];
    try {
      var parsed = JSON.parse(dataEl.textContent);
      if (parsed && Array.isArray(parsed.stories)) stories = parsed.stories;
    } catch (e) {
      return; // bad JSON -> leave bubbles as inert, page fine
    }
    if (!stories.length) return;

    var bubbles = Array.prototype.slice.call(
      module.querySelectorAll('.vibee-stories__bubble')
    );

    var DEBUG = false;
    try { DEBUG = /[?&]storydebug=1/.test(window.location.search); } catch (e) {}

    // ---- locale strings (from data-* on the rail, with fallbacks) ----
    var t = {
      close: dataEl.getAttribute('data-l-close') || 'Kapat',
      mute: dataEl.getAttribute('data-l-mute') || 'Sesi aç',
      unmute: dataEl.getAttribute('data-l-unmute') || 'Sesi kapat',
      pause: dataEl.getAttribute('data-l-pause') || 'Duraklat',
      prev: dataEl.getAttribute('data-l-prev') || 'Önceki',
      next: dataEl.getAttribute('data-l-next') || 'Sonraki'
    };

    // ---------- viewed-state (sessionStorage, guarded) ----------
    var SEEN_KEY = 'vibee_stories_seen';
    function getSeen() {
      try {
        var raw = sessionStorage.getItem(SEEN_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) { return {}; }
    }
    function markSeen(i) {
      try {
        var seen = getSeen();
        seen[String(i)] = 1;
        sessionStorage.setItem(SEEN_KEY, JSON.stringify(seen));
      } catch (e) {}
      try {
        if (bubbles[i]) bubbles[i].classList.add('is-seen');
      } catch (e) {}
    }
    (function paintSeen() {
      var seen = getSeen();
      for (var i = 0; i < bubbles.length; i++) {
        if (seen[String(i)]) bubbles[i].classList.add('is-seen');
      }
    })();

    // ---------- build the overlay once ----------
    var SVG_NS = 'http://www.w3.org/2000/svg';
    function svg(paths, opts) {
      var s = document.createElementNS(SVG_NS, 'svg');
      s.setAttribute('viewBox', '0 0 24 24');
      s.setAttribute('fill', 'none');
      s.setAttribute('aria-hidden', 'true');
      if (opts && opts.cls) s.setAttribute('class', opts.cls);
      for (var i = 0; i < paths.length; i++) {
        var p = document.createElementNS(SVG_NS, 'path');
        p.setAttribute('d', paths[i]);
        p.setAttribute('stroke', 'currentColor');
        p.setAttribute('stroke-width', '2');
        p.setAttribute('stroke-linecap', 'round');
        p.setAttribute('stroke-linejoin', 'round');
        s.appendChild(p);
      }
      return s;
    }

    var player = document.createElement('div');
    player.className = 'vibee-stories-player';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-label', module.querySelector('.vibee-stories__rail')
      ? (module.querySelector('.vibee-stories__rail').getAttribute('aria-label') || 'Stories')
      : 'Stories');
    player.hidden = true;

    var stage = document.createElement('div');
    stage.className = 'vibee-stories-player__stage';

    var scrimTop = document.createElement('div');
    scrimTop.className = 'vibee-stories-player__scrim vibee-stories-player__scrim--top';
    var scrimBottom = document.createElement('div');
    scrimBottom.className = 'vibee-stories-player__scrim vibee-stories-player__scrim--bottom';

    // progress segments
    var progress = document.createElement('div');
    progress.className = 'vibee-stories-player__progress';
    var segFills = [];
    for (var si = 0; si < stories.length; si++) {
      var seg = document.createElement('div');
      seg.className = 'vibee-stories-player__seg';
      var fill = document.createElement('div');
      fill.className = 'vibee-stories-player__seg-fill';
      seg.appendChild(fill);
      progress.appendChild(seg);
      segFills.push(fill);
    }

    // nav zones — <div role=button>, bkz. dosya başındaki karar #4
    var nav = document.createElement('div');
    nav.className = 'vibee-stories-player__nav';
    function mkZone(cls, label) {
      var z = document.createElement('div');
      z.className = 'vibee-stories-player__zone ' + cls;
      z.setAttribute('role', 'button');
      z.setAttribute('tabindex', '0');
      z.setAttribute('aria-label', label);
      return z;
    }
    var zonePrev = mkZone('vibee-stories-player__zone--prev', t.prev);
    var zoneCenter = mkZone('vibee-stories-player__zone--center', t.pause);
    var zoneNext = mkZone('vibee-stories-player__zone--next', t.next);
    nav.appendChild(zonePrev);
    nav.appendChild(zoneCenter);
    nav.appendChild(zoneNext);

    // pause badge
    var pauseBadge = document.createElement('div');
    pauseBadge.className = 'vibee-stories-player__pause-badge';
    pauseBadge.appendChild(svg(['M9 6v12', 'M15 6v12']));

    // controls
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'vibee-stories-player__close';
    closeBtn.setAttribute('aria-label', t.close);
    closeBtn.appendChild(svg(['M6 6l12 12', 'M18 6L6 18']));

    var muteBtn = document.createElement('button');
    muteBtn.type = 'button';
    muteBtn.className = 'vibee-stories-player__mute';
    muteBtn.setAttribute('aria-label', t.mute);
    var iconMuted = svg(['M11 5L6 9H3v6h3l5 4V5z', 'M16 9l4 6', 'M20 9l-4 6'], { cls: 'vibee-stories-player__icon vibee-stories-player__icon--muted' });
    var iconUnmuted = svg(['M11 5L6 9H3v6h3l5 4V5z', 'M16 8a4 4 0 0 1 0 8'], { cls: 'vibee-stories-player__icon vibee-stories-player__icon--unmuted' });
    muteBtn.appendChild(iconMuted);
    muteBtn.appendChild(iconUnmuted);

    var titleEl = document.createElement('p');
    titleEl.className = 'vibee-stories-player__title';

    stage.appendChild(scrimTop);
    stage.appendChild(scrimBottom);
    stage.appendChild(nav);
    stage.appendChild(pauseBadge);
    stage.appendChild(progress);
    stage.appendChild(titleEl);
    stage.appendChild(closeBtn);
    stage.appendChild(muteBtn);
    player.appendChild(stage);
    document.body.appendChild(player);

    var debugEl = null;
    if (DEBUG) {
      debugEl = document.createElement('div');
      debugEl.setAttribute('style',
        'position:fixed;left:6px;bottom:6px;z-index:2147483647;background:rgba(0,0,0,.8);' +
        'color:#0f0;font:10px/1.4 monospace;padding:4px 6px;pointer-events:none;white-space:pre');
      document.body.appendChild(debugEl);
    }

    // ---------- state ----------
    var current = -1;
    var isOpen = false;
    var lastFocus = null;
    var unmuted = false;
    var errorRetried = false;
    var openedByKeyboard = false;
    var video = null; // her story'de taze element (karar #2)

    function setSegments(idx, ratio) {
      for (var i = 0; i < segFills.length; i++) {
        var f = segFills[i];
        var parent = f.parentNode;
        if (i < idx) {
          parent.classList.add('is-done');
          f.style.transform = 'scaleX(1)';
        } else if (i === idx) {
          parent.classList.remove('is-done');
          f.style.transform = 'scaleX(' + (ratio || 0) + ')';
        } else {
          parent.classList.remove('is-done');
          f.style.transform = 'scaleX(0)';
        }
      }
    }

    function onTimeUpdate() {
      try {
        if (!video || current < 0 || !video.duration || !isFinite(video.duration)) return;
        var ratio = video.currentTime / video.duration;
        if (ratio < 0) ratio = 0;
        if (ratio > 1) ratio = 1;
        var f = segFills[current];
        if (f) f.style.transform = 'scaleX(' + ratio + ')';
      } catch (e) {}
    }

    function onEnded() {
      try {
        if (segFills[current]) segFills[current].style.transform = 'scaleX(1)';
        next();
      } catch (e) {}
    }

    // Seçilen kaynak oynamazsa hikâyenin diğer kaynağını BİR kez dene
    function onError() {
      try {
        if (!video || current < 0 || errorRetried) return;
        var story = stories[current];
        var srcs = (story && story.sources) || [];
        var cur = video.getAttribute('src') || '';
        for (var i = 0; i < srcs.length; i++) {
          if (srcs[i] && srcs[i].src && srcs[i].src !== cur) {
            errorRetried = true;
            video.setAttribute('src', srcs[i].src);
            video.load();
            playVideo();
            return;
          }
        }
      } catch (e) {}
    }

    function mkVideo() {
      var v = document.createElement('video');
      v.className = 'vibee-stories-player__video';
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('muted', ''); // iOS autoplay politikası attribute'a bakar
      v.muted = !unmuted;
      v.defaultMuted = true;
      v.setAttribute('preload', 'none');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('tabindex', '-1');
      v.addEventListener('timeupdate', onTimeUpdate);
      v.addEventListener('ended', onEnded);
      v.addEventListener('error', onError);
      return v;
    }

    function dropVideo() {
      if (!video) return;
      try { video.pause(); } catch (e) {}
      try { video.removeAttribute('src'); video.load(); } catch (e) {}
      try { video.remove(); } catch (e) {}
      video = null;
    }

    // İlk oynatılabilir kaynağı seç: önce video/mp4 (Liquid tarafı zaten
    // mp4'ü öne dizer), sonra canPlayType'ın reddetmediği ilk kaynak.
    function pickSource(story) {
      var srcs = (story && story.sources) || [];
      var probe = video || document.createElement('video');
      var i;
      for (i = 0; i < srcs.length; i++) {
        if (srcs[i] && srcs[i].src && srcs[i].type === 'video/mp4') return srcs[i].src;
      }
      for (i = 0; i < srcs.length; i++) {
        if (!srcs[i] || !srcs[i].src) continue;
        try {
          if (!srcs[i].type || probe.canPlayType(srcs[i].type) !== '') return srcs[i].src;
        } catch (e) { return srcs[i].src; }
      }
      return (srcs.length && srcs[0] && srcs[0].src) || '';
    }

    function loadStory(idx) {
      var story = stories[idx];
      if (!story) return;
      try {
        dropVideo();
        video = mkVideo();
        if (story.poster) video.setAttribute('poster', story.poster);
        var url = pickSource(story);
        if (!url) return;
        video.setAttribute('src', url);
        stage.insertBefore(video, stage.firstChild);
        video.muted = !unmuted;
        if (video.muted) video.setAttribute('muted', '');
        else video.removeAttribute('muted');
        video.load();
      } catch (e) {}
    }

    function playVideo() {
      try {
        if (!video) return;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () { /* autoplay blocked; ignore */ });
        }
      } catch (e) {}
    }

    function show(idx) {
      if (idx < 0 || idx >= stories.length) return;
      current = idx;
      errorRetried = false;
      titleEl.textContent = (stories[idx] && stories[idx].title) || '';
      setSegments(idx, 0);
      loadStory(idx);
      markSeen(idx);
      player.classList.remove('is-paused');
      playVideo();
    }

    function lockScroll(lock) {
      try {
        document.documentElement.style.overflow = lock ? 'hidden' : '';
        document.body.style.overflow = lock ? 'hidden' : '';
      } catch (e) {}
    }

    // Transition YOK (karar #3): player anında görünür, play() jest içinde.
    function open(idx, originBtn) {
      if (isOpen) { show(idx); return; }
      isOpen = true;
      lastFocus = originBtn || document.activeElement;
      player.hidden = false;
      player.classList.add('is-open');
      lockScroll(true);
      show(idx);
      try { closeBtn.focus(); } catch (e) {}
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      player.classList.remove('is-open');
      player.classList.remove('is-paused');
      dropVideo();
      lockScroll(false);
      player.hidden = true;
      // Odak SADECE klavyeyle açıldıysa geri verilir. Dokunmatikte programatik
      // focus, iOS/Safari'de balonda mavi odak dikdörtgeni + halka bırakıyordu.
      if (openedByKeyboard) {
        try {
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        } catch (e) {}
      }
    }

    function next() {
      if (current >= stories.length - 1) { close(); return; }
      show(current + 1);
    }
    function prev() {
      if (current <= 0) { show(0); return; }
      show(current - 1);
    }

    function togglePlay() {
      try {
        if (!video) return;
        if (video.paused) {
          player.classList.remove('is-paused');
          playVideo();
        } else {
          video.pause();
          player.classList.add('is-paused');
        }
      } catch (e) {}
    }

    function setUnmuted(on) {
      unmuted = !!on;
      try {
        if (video) {
          video.muted = !unmuted;
          if (video.muted) video.setAttribute('muted', '');
          else video.removeAttribute('muted');
        }
      } catch (e) {}
      if (unmuted) {
        player.classList.add('is-unmuted');
        muteBtn.setAttribute('aria-label', t.unmute);
      } else {
        player.classList.remove('is-unmuted');
        muteBtn.setAttribute('aria-label', t.mute);
      }
    }

    if (DEBUG) {
      window.setInterval(function () {
        try {
          if (!debugEl) return;
          if (!video) { debugEl.textContent = 'video: yok'; return; }
          var q = video.getVideoPlaybackQuality ? video.getVideoPlaybackQuality() : null;
          debugEl.textContent =
            't=' + (Math.round(video.currentTime * 10) / 10) +
            ' rs=' + video.readyState +
            ' vw=' + video.videoWidth +
            ' fr=' + (q ? q.totalVideoFrames : '?') +
            ' paused=' + video.paused +
            ' err=' + (video.error ? video.error.code : '-') +
            '\nsrc=' + (video.currentSrc || '').split('/').pop().slice(0, 34);
        } catch (e) {}
      }, 500);
    }

    // ---------- wire events ----------
    bubbles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        try {
          var idx = parseInt(btn.getAttribute('data-vibee-story-index'), 10);
          if (isNaN(idx)) return;
          // e.detail === 0 => klavye kaynaklı click (Enter/Space)
          openedByKeyboard = !!(e && e.detail === 0);
          open(idx, btn); // .play() runs inside this user-gesture handler
        } catch (e2) {}
      });
    });

    [zonePrev, zoneCenter, zoneNext].forEach(function (z) {
      z.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); z.click(); }
      });
    });
    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    muteBtn.addEventListener('click', function (e) { e.stopPropagation(); setUnmuted(!unmuted); });
    zonePrev.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    zoneNext.addEventListener('click', function (e) { e.stopPropagation(); next(); });
    zoneCenter.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });

    // keyboard
    player.addEventListener('keydown', function (e) {
      try {
        if (!isOpen) return;
        var key = e.key;
        if (key === 'Escape') { e.preventDefault(); close(); }
        else if (key === 'ArrowRight') { e.preventDefault(); next(); }
        else if (key === 'ArrowLeft') { e.preventDefault(); prev(); }
        else if (key === 'Tab') {
          // focus trap
          var focusables = [muteBtn, zonePrev, zoneCenter, zoneNext, closeBtn];
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        }
      } catch (err) {}
    });

    // swipe-down to close
    var touchStartY = 0, touchStartX = 0, touching = false;
    stage.addEventListener('touchstart', function (e) {
      try {
        if (!e.touches || !e.touches.length) return;
        touching = true;
        touchStartY = e.touches[0].clientY;
        touchStartX = e.touches[0].clientX;
      } catch (err) {}
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      try {
        if (!touching || !e.changedTouches || !e.changedTouches.length) return;
        touching = false;
        var dy = e.changedTouches[0].clientY - touchStartY;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (dy > 80 && Math.abs(dy) > Math.abs(dx) * 1.5) close();
      } catch (err) {}
    }, { passive: true });

    // page hidden -> pause (yalnızca gerçekten gizliyken)
    document.addEventListener('visibilitychange', function () {
      try {
        if (document.hidden && isOpen && video && !video.paused) {
          video.pause();
          player.classList.add('is-paused');
        }
      } catch (e) {}
    });
  } catch (e) {
    // Swallow everything: bubbles remain inert buttons, page stays usable.
    if (window && window.console && console.warn) {
      console.warn('[vibee-pdp-stories] disabled:', e);
    }
  }
})();
